import { createService } from '@bonanza-social/toolkit/api';
import {
  GamingHistoryResponseSchema,
  TransactionHistoryResponseSchema,
} from './HistoryService.schemas';

export default createService(
  {
    getTransactionHistory: {
      method: 'GET',
      url: '/paymentHistory',
      responseSchema: TransactionHistoryResponseSchema,
    },
    getGamingHistory: {
      method: 'GET',
      url: '/gamingHistory',
      responseSchema: GamingHistoryResponseSchema,
    },
    getCoinsGamingHistory: {
      method: 'GET',
      url: '/coinsGamingHistory',
      responseSchema: GamingHistoryResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
